import { FC, ReactNode } from "react";
import { Switch } from "shared/components/forms/Switch";
import { CheckComponent } from "./components/CheckComponent";

export const SwitchWithReadOnlyMode: FC<{
  checked: boolean;
  label?: ReactNode;
  onChange: (v: boolean) => void;
  disabled?: boolean;
  readOnly?: boolean;
}> = ({ checked, label, onChange, disabled = false, readOnly = false }) => {
  return (
    <div className="py-2">
      {readOnly ? (
        <CheckComponent checked={checked} label={label} />
      ) : (
        <Switch
          onChange={onChange}
          checked={checked}
          disabled={disabled}
          label={label}
        />
      )}
    </div>
  );
};
